import React from "react"
import { CustomModal } from "./modal"
import { Button } from "./"
import { Grid } from '@material-ui/core';
import * as Yup from "yup"
import { Formik, Form } from "formik"
import { useMutation, useQuery } from "react-query"
import { createAgencyUser, fetchCountries } from "../services"
import Select from "react-select"
import { v4 as uuidv4 } from 'uuid'

function AddAgencyModal({ isOpen, onClose }) {

    const { mutate: createUser, isLoading: isCreating } = useMutation(data => createAgencyUser(data), {
        onSuccess: () => {
            alert('Agency created successfully')
            onClose()
        },
        onError: error => {
            alert(error.data?.message)
        }
    })

    const { data: countries = [], isLoading: isCountriesLoading } = useQuery(["countries"], () => fetchCountries(), {
        select: (data) => data.countries.map(e => ({ label: e.name, value: e.id })),
        refetchOnWindowFocus: false,
        enabled: isOpen
    })

    return (
        <CustomModal
            open={isOpen}
            onClose={onClose}
            className="commonCustomModal feedbackModal"
            body={
                <Formik
                    initialValues={{
                        name: '',
                        agency_name: '',
                        password: '',
                        email: '',
                        countries: [],
                    }}
                    validationSchema={Yup.object().shape({
                        name: Yup.string().required('Name is required'),
                        agency_name: Yup.string().required('Agency name is required'),
                        password: Yup.string().required('Passworkd is required'),
                        email: Yup.string().required('Email is required'),
                        countries: Yup.array().min(1, 'Select at leaset 1 country'),
                    })}
                    validateOnChange={false}
                    validateOnBlur={false}
                    onSubmit={(values, { setSubmitting }) => {
                        const countries = values.countries.map(e => e.value)
                        const data = { ...values, countries }

                        createUser({ ...data, uuid: uuidv4() })
                        setSubmitting(false);
                    }}
                >
                    {({ handleChange, errors, values, touched, setFieldValue }) => (
                        <Form className="form mt-30">
                            <Grid container>
                                <Grid item lg={12}>
                                    <div className="mb-20">
                                        <label htmlFor="name">First & last name</label>
                                        <input required type="text" name="name" value={values.name} onChange={handleChange} className="stllr-input" placeholder="Enter name" />
                                        {errors.name && touched.name ? (
                                            <span className="v-error">{errors.name}</span>
                                        ) : null}
                                    </div>
                                </Grid>
                                <Grid item lg={12}>
                                    <div className="mb-20">
                                        <label htmlFor="password">User Password</label>
                                        <input required type="password" name="password" value={values.password} onChange={handleChange} className="stllr-input" placeholder="Enter password" />
                                        {errors.password && touched.password ? (
                                            <span className="v-error">{errors.password}</span>
                                        ) : null}
                                    </div>
                                </Grid>
                                <Grid item lg={12}>
                                    <div className="mb-20">
                                        <label htmlFor="email">User Email</label>
                                        <input required type="email" name="email" value={values.email} onChange={handleChange} className="stllr-input" placeholder="Enter email" />
                                        {errors.email && touched.email ? (
                                            <span className="v-error">{errors.email}</span>
                                        ) : null}
                                    </div>
                                </Grid>
                                <Grid item lg={12}>
                                    <div className="mb-20">
                                        <label htmlFor="agency_name">Agency name</label>
                                        <input required type="text" name="agency_name" value={values.agency_name} onChange={handleChange} className="stllr-input" placeholder="Enter agency name" />
                                        {errors.agency_name && touched.agency_name ? (
                                            <span className="v-error">{errors.agency_name}</span>
                                        ) : null}
                                    </div>
                                </Grid>
                                <Grid item lg={12}>
                                    <div className="mb-20">
                                        <label htmlFor="country_id">Agency countries</label>
                                        <Select
                                            name='country'
                                            placeholder="Select countries"
                                            options={countries}
                                            value={values.countries}
                                            onChange={(value) => setFieldValue('countries', value)}
                                            isMulti
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    height: 42,
                                                    minHeight: 42
                                                })
                                            }}
                                        />
                                        {errors.countries && touched.countries ? (
                                            <span className="v-error">{errors.countries}</span>
                                        ) : null}
                                    </div>
                                </Grid>
                            </Grid>

                            <div className="is-flex aic">
                                <Button
                                    className="stllr-btn primary btn-md fw7"
                                    text="Submit"
                                    type="submit"
                                    disabled={isCreating}
                                />
                            </div>
                        </Form>
                    )}
                </Formik>
            }
        />
    );
}


export { AddAgencyModal }
